import keyMirror from 'keymirror'

export default keyMirror({
  GET_CONFIGURATION_PERS_COMNS_REQUEST: null,
  GET_CONFIGURATION_PERS_COMNS_SUCCESS: null,
  GET_CONFIGURATION_PERS_COMNS_FAILED: null,

  UPDATE_FILTER_CONFIGURATION_PERS_COMN_SUCCESS: null,
  CLEAR_FILTER_CONFIGURATION_PERS_COMN_SUCCESS: null
})
